import MusicPlayer from './MusicPlayer'
export { MusicContainer } from './_musicPlayerStyles'

export default MusicPlayer
